import React from "react";
// import { NumericFormat } from "react-number-format"; // Use named export
import * as S from "./InputMonetary.styled";
import { ReactComponent as IconError } from "../../../../../assets/images/habitacional/rounded-warning.svg";

const InputMonetary = ({
    title,
    value,
    onChange,
    placeholder,
    defaultValue,
    icon,
    hasError,
    errorMessage,
    type,
    maxLength,
    isRequired,
    mask, // Not needed with react-number-format for currency
    margin,
    CalendarPicker,
    ...props
}) => {
    return (
        <S.InputContainer>
            <S.Title htmlFor={title} margin={margin}>
                {title} {isRequired && <S.RequiredIcon>*</S.RequiredIcon>}
            </S.Title>
            <S.CurrencyStyledTextField
                value={value}
                onValueChange={(values) => {
                    onChange(values.value);
                }}
                thousandSeparator="."
                decimalSeparator=","
                prefix="R$ "
                placeholder={placeholder}
                decimalScale={2}
                fixedDecimalScale
                isNumericString
                {...props}
            />

            {hasError && errorMessage && (
                <S.ErrorMessage>
                    <IconError />
                    {errorMessage}
                </S.ErrorMessage>
            )}
        </S.InputContainer>
    );
};

export default InputMonetary;
